import { motion, useInView } from "framer-motion";
import { useRef, useEffect, useState } from "react";

const SlideUp = ({
  children,
  delay = 0,
  triggerOnView = false,
  manualStart = false,
  start = false,
  className = "",
}) => {
  const variants = {
    hidden: { opacity: 0, y: 85 },
    visible: { opacity: 1, y: 0 },
  };

  // If manualStart is true, animate depends on `start` prop
  // Else if triggerOnView is true, use viewport + whileInView
  // Else animate immediately (controlled by delay only)

  if (manualStart) {
    return (
      <motion.div
        variants={variants}
        initial="hidden"
        animate={start ? "visible" : "hidden"}
        transition={{ duration: 0.6, ease: "easeOut", delay }}
      >
        {children}
      </motion.div>
    );
  }

  if (triggerOnView) {
    return (
      <motion.div
        variants={variants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.6, ease: "easeOut", delay }}
      >
        {children}
      </motion.div>
    );
  }

  // Default immediate animate (with delay)
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.6, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
};

export default SlideUp;

// const SlideUp = ({
//   children,
//   manualStart = false,   // if true, animation waits for `start` prop to trigger
//   start = false,         // external trigger to start animation if manualStart=true
//   triggerInView = false, // if true, animation starts when element enters viewport
//   duration = 1.0,
//   ease = "easeOut",
// }) => {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true });
//   const [shouldAnimate, setShouldAnimate] = useState(!manualStart);

//   useEffect(() => {
//     if (manualStart) {
//       setShouldAnimate(start);
//     } else if (triggerInView) {
//       setShouldAnimate(inView);
//     }
//   }, [manualStart, start, triggerInView, inView]);

//   return (
//     <motion.div
//       ref={ref}
//       initial={{ opacity: 0, y: 100 }}
//       animate={shouldAnimate ? { opacity: 1, y: 0 } : {}}
//       transition={{ duration, ease }}
//     >
//       {children}
//     </motion.div>
//   );
// };

// export default SlideUp;
